/* eslint-disable i18next/no-literal-string */
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, CheckboxProps, FormControl, FormControlLabel, FormGroup, FormHelperText } from 'ui';

type CheckboxFieldProps = CheckboxProps & {
  name: string;
  label: React.ReactNode;
};

export const CheckboxField = ({ name, label, required = false, ...rest }: CheckboxFieldProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={
        required
          ? {
              required: 'This field is required',
            }
          : {}
      }
      render={({ field, fieldState }) => {
        const { error } = fieldState;
        return (
          <FormControl required={required} error={Boolean(error)}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    {...rest}
                    checked={Boolean(field.value)}
                    onChange={(e) => field.onChange(e.target.checked)}
                    required={required}
                  />
                }
                label={label}
              />
            </FormGroup>
            {error ? <FormHelperText>{error.message}</FormHelperText> : null}
          </FormControl>
        );
      }}
    />
  );
};
